<template>
  <div>
    <BankConnectionModal :mobile-view="getMobileAppView" :show-modal="true" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

import BankConnectionModal from "@/components/bank/ui/BankConnectionModal";

export default {
  name: "BankConnection",
  components: {
    BankConnectionModal
  },
  props: {

  },
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters({ 
      getMobileAppView: "main/getMobileAppView",
    })
  },
  created () {
    if (!this.getMobileAppView) {
      this.$router.push({ name: 'Bank' })
    }
  },
  methods: {
  }
}
</script>
<style scoped lang="scss">

</style>
